export const ValidatePassword = password => {
  // rules
  const minChars = 8
  const maxChars = 20
  const containsLowercase = /[a-z]/
  const containsUppercase = /[A-Z]/
  const containsWhitespace = /\s/
  const containsNumber = /\d/

  const tests = {
    validLength: false,
    noWhitespace: false,
    hasLowercase: false,
    hasUppercase: false,
    hasNumber: false,
  }

  if (password.length <= maxChars && password.length >= minChars) {
    tests.validLength = true
  }

  tests.noWhitespace = !containsWhitespace.test(password)
  tests.hasLowercase = containsLowercase.test(password)
  tests.hasUppercase = containsUppercase.test(password)
  tests.hasNumber = containsNumber.test(password)

  return tests
}

export default ValidatePassword



// WEBPACK FOOTER //
// ./src/legacy/components/ValidatePassword/index.js